import React from 'react';
import './MainContent.css';
import {BsGear} from 'react-icons/bs'
import {AiOutlineQuestionCircle} from 'react-icons/ai'

import img_panoramica from '../../Assets/img/taller_panoramica.png';
import stone from '../../Assets/img/stoneridge_tac.jpg';
import {InfoCard} from '../InfoCard/InfoCard'
import {ContactCard} from './ContactCard'
import Logo from '../../Assets/img/LOGO.svg';


const texto_informacion =[
    [
        "infocard_about",
        "Sobre Nosotros", 
        `Una larga trayectoria, la satisfacción de nuestros clientes y un gran trato
        avalan la calidad de nuestro taller. Además de dar servicio tanto a empresa pública, privada
        y particulares, siempre estaremos dispuestos a hacer todo lo que esté en nuestra mano para 
        ofrecer el mejor servicio.`,
        <AiOutlineQuestionCircle size='10rem'/>
    ],
    [
        "infocard_about", 
        "Servicio de Tacógrafos", 
        `Centro técnico autorizado para realizar instalaciones, activaciones, inspecciones y 
        reparaciones, así como para efectuar verificaciones y controles de tacógrafos, 
        tanto analógicos como digitales.`,      
        <BsGear size='10rem'/>],

    
]

class Inicio extends React.Component {

    render(){
        var information_card = texto_informacion.map(function(vector_info){
            return <InfoCard id={vector_info[0]} title={vector_info[1]} parragraph={vector_info[2]} icon={vector_info[3]}/>
        })
        
        return(
            <div className="main_content_div">
                <img className="img_logo" src={Logo}/>
                <div className="main_content_info">
                    <h2 className="container_title">
                        Reparación de vehículos y tacógrafos
                    </h2>
                    <p>
                        Con más de 25 años de experiencia, en ServiDiesel Ciudad Real ofrecemos 
                        servicios de reparación y mantenimiento para todo tipo de vehículos.
                    </p>
                </div>
                <div className='main_content_pictures'>
                <img alt='panoramica' src={img_panoramica}/>
                <img alt='stones' src={stone}/>

                </div>
                <ContactCard/>
                {information_card}
            </div>
        )
    }

}

export default Inicio